import { useState } from 'react';
import { Timer } from "@phosphor-icons/react";
import { Link } from 'react-router-dom';
import { Button } from '../button/Button';
import { motion } from "motion/react";
import './Navigation.scss';

type NavigationProps = {
    isLoggedIn?: boolean;
    remainingTime?: number | null;
    profilePic?: string | null;
};

const Navigation: React.FC<NavigationProps> = ({ isLoggedIn, remainingTime, profilePic }) => {

  const subMenuAnimate = {
    enter: {
      opacity: 1,
      transition: {
        duration: 0.2
      },
      display: "block"
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.2,
        delay: 0.3
      },
      transitionEnd: {
        display: "none"
      }
    }
  };

  const [isHover, toggleHover] = useState(false);
  const toggleHoverMenu = () => {
    toggleHover(!isHover);
  };

  const timerDisplay = <>
    <Timer /> {`${remainingTime} min`}
  </>

  const profileDisplay = isLoggedIn && (
    <img src={profilePic || "./img/profile.png"  } alt="Profile" />
  );



  return (
    <nav>

      <Link to="/" className="logo">
        <img src="./img/logo.svg"/>
        <span>PracticeRun.ai</span>
      </Link>

      {isLoggedIn ? (
        <div className="menu">
            <span className="credits">
              { remainingTime != null ? timerDisplay : ""}
            </span>

            { profileDisplay && (
              <motion.span
                className="profile"
                onHoverStart={toggleHoverMenu}
                onHoverEnd={toggleHoverMenu}
              >
                { profileDisplay }

                <motion.div
                  className="account-actions"
                  initial="exit"
                  animate={isHover ? "enter" : "exit"}
                  variants={subMenuAnimate}
                >
                  <a href="/aiproxy/logout">Logout</a>
                </motion.div>
              </motion.span>
            )}

        </div>
      ) : (
        <div className="menu">
          <LinkedinButton />
        </div>
      )}
    </nav>
  );
};

export default Navigation;

function LinkedinButton() {
  const handleClick = () => {
    window.location.href = '/aiproxy/start_linkedin_login_flow';
  };
  return (
    <>
      <Button
        buttonSize="sm"
        buttonStyle="primary"
        label="Login"
        onClick={handleClick}
      />
    </>
  );
}
